import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { Layout, Card } from 'antd';
import { graphql } from 'react-apollo';
import LoginForm from './form';
import { getCurrentUser } from '../../authorization/queries/getCurrentUser';
import Spinner from '../../spinner/spinner';
import { SiteLogo } from '../../common/siteLogo/siteLogo'
import { Footer } from '../../common/footer/footer';
import './login.css';

const { Content } = Layout;

class LoginPage extends Component {
  redirect = (currentUser) => this.props.history.replace('/dashboard');

  render() {
    if (this.props.data.loading) {
      return <Spinner />
    } else if (this.props.data.current_user) {
      return <Redirect to="/dashboard" />
    } else {
      return (
        <Layout className="login-page login-page__layout">
          <Content className="login-page__content">
            <SiteLogo/>
            <Card className="login-page__content-card">
              <LoginForm onSubmit={this.redirect}/>
            </Card>
          </Content>
          <Footer className="footer-transparent"/>
        </Layout>
      );
    }
  }
}

export default graphql(getCurrentUser)(LoginPage);



// WEBPACK FOOTER //
// ./src/components/pages/login/login.js